export var Resource;
(function (Resource) {
    Resource["Partner"] = "Partner";
    Resource["PartnerGroup"] = "PartnerGroup";
    Resource["PartnerGroupRule"] = "PartnerGroupRule";
    Resource["PartnerGroupRuleValue"] = "PartnerGroupRuleValue";
    Resource["User"] = "User";
    Resource["UserGroup"] = "UserGroup";
    Resource["UserGroupRuleValue"] = "UserGroupRuleValue";
    Resource["UserGroupRule"] = "UserGroupRule";
    Resource["UserCommunicationPreference"] = "UserCommunicationPreference";
    Resource["MembershipFeature"] = "MembershipFeature";
    Resource["ActiveMembershipFeature"] = "ActiveMembershipFeature";
})(Resource || (Resource = {}));
